import { Product, ProductGroup } from '../../product.js';

export type ProductTransformerValue = Product[] | ProductGroup[];
export type ProductTransformerResultType<T> = T extends IProductTransformer<infer V> ? V : never;

export default interface IProductTransformer<T extends ProductTransformerValue> {
  transform(filteredProducts: Product[], allProducts: Product[], allProductGroups: ProductGroup[]): T;
}

export class FlatProductTransformer implements IProductTransformer<Product[]> {
  transform(filteredProducts: Product[], allProducts: Product[], allProductGroups: ProductGroup[]): Product[] {
    return filteredProducts;
  }
}

export class HierarchicalProductTransformer implements IProductTransformer<ProductGroup[]> {
  constructor(private readonly depth = 0) {
    if (depth > 0) {
      throw new Error('HierarchicalProductTransformer: nested ProductGroups are not supported yet');
      // @todo: NYI
    }
  }

  private static filter(productIds: string[], allProductGroups: ProductGroup[]): ProductGroup[] {
    const result: ProductGroup[] = [];

    for (const group of allProductGroups) {
      const newGroup = { ...group, children: [] };

      for (const child of group.children) {
        if (productIds.includes(child._id)) {
          newGroup.children.push(child);
        }
      }

      if (newGroup.children.length > 0) {
        result.push(newGroup);
      }
    }

    return result;
  }

  transform(products: Product[], allProducts: Product[], allProductGroups: ProductGroup[]): ProductGroup[] {
    return HierarchicalProductTransformer.filter(products.map(product => product._id), allProductGroups);
  }
}
